import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { useCallback } from 'react';
import { setIsSelectingSideBetTarget } from '../../../../redux/actions/sideBetsActions';
import { useAppDispatch, useAppSelector } from '../../../../redux/store';
import { SIDE_BET_BUTTON_BACKGROUND_COLOR_NUM, SIDE_BET_BUTTON_HOVER_COLOR_NUM, SIDE_BETS_ACCENT_COLOR_NUM } from '../../../../styles/colors';
import { getCurrencyAmountString } from '../../../../utils/currencyUtils';
import { Button } from '../../pixiComponents/button';
export const PixiSideBetButton = ({ bounds }) => {
    const sideBetCost = useAppSelector((state) => state.poker.sideBetCost);
    const isSelectingSideBetTarget = useAppSelector((state) => state.sideBets.selectSideBetTargetStartTimestampMs !== undefined);
    const dispatch = useAppDispatch();
    const onClickSideBet = useCallback(() => {
        dispatch(setIsSelectingSideBetTarget(!isSelectingSideBetTarget));
    }, [dispatch, isSelectingSideBetTarget]);
    if (sideBetCost === undefined) {
        return null;
    }
    const labelProperties = isSelectingSideBetTarget
        ? { label: 'CANCEL', bitmapTextStyleType: 'side-bet-button-label' }
        : { label: 'SIDE BET', bitmapTextStyleType: 'side-bet-button-label' };
    const subLabelProperties = isSelectingSideBetTarget
        ? {
            label: 'SIDE BET',
            bitmapTextStyleType: 'side-bet-button-sub-label'
        }
        : {
            label: getCurrencyAmountString(sideBetCost, 'jacks').toUpperCase(),
            bitmapTextStyleType: 'side-bet-button-sub-label'
        };
    return (_jsx(Button, { pixiObjectData: { type: isSelectingSideBetTarget ? 'cancel-side-bet-button' : 'side-bet-button' }, onClick: onClickSideBet, labelProperties: labelProperties, subLabelProperties: subLabelProperties, bounds: bounds, backgroundColor: SIDE_BET_BUTTON_BACKGROUND_COLOR_NUM, backgroundHoverColor: SIDE_BET_BUTTON_HOVER_COLOR_NUM, lineColor: SIDE_BETS_ACCENT_COLOR_NUM, lineWidth: 2 }, isSelectingSideBetTarget ? 'cancel' : 'side-bet'));
};
